import { render, staticRenderFns } from "./VenueEmails.vue?vue&type=template&id=425b3f14&"
import script from "./VenueEmails.vue?vue&type=script&lang=js&"
export * from "./VenueEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports